<nb-card class="linked-equipment-dialog">
  <nb-card-header class="header">
    <div class="title">{{ title }}</div>
    <div class="header-actions">
      <span class="close-btn" (click)="cancel()">
        <i class="fa-light fa-xmark"></i>
      </span>
    </div>
  </nb-card-header>
  <nb-card-body class="body">
    @if (loading) {
      <div class="loading-container">
        <nb-spinner size="medium"></nb-spinner>
      </div>
    } @else {
      @if (!isCreationType) {
        @if (equipmentList.length === 0 && !showFutureEquipment) {
          <div class="empty-state">
          </div>
          @if (showLinkButton()) {
            <div class="footer-icon">
              <button class="paperclip-icon rounded-circle border border-0" (click)="openAttachEquipmentDialog()">
                <i class="fa-light fa-link"></i>
              </button>
            </div>
          }
        } @else if (equipmentList.length > 0) {
          <div class="equipment-list">
            @for (equipment of equipmentList; track equipment.id) {
              <div class="equipment-item">
                <div class="equipment-content">
                  <div class="equipment-thumbnail">
                    @if (getEquipmentThumbnail(equipment)) {
                      <img [src]="getEquipmentThumbnail(equipment)" [alt]="equipment.label" />
                    } @else {
                      <div class="placeholder-thumbnail">
                        <i class="fa-light fa-image"></i>
                      </div>
                    }
                  </div>
                  <div class="equipment-details">
                    <div class="equipment-label">
                      {{ equipment.label || '-' }}
                    </div>

                    <div class="equipment-info perimeter-info">
                      <span class="info-item">
                        <span class="perimeter-value perimeter-label-alt">{{ getPerimeterHierarchy(equipment) }}</span>
                      </span>
                    </div>

                    <div class="equipment-info state-info">
                      <span class="info-item">
                        <ng-container *ngIf="getLastEvaluationDate(equipment) as lastDate">
                          {{ lastDate }}
                        </ng-container>
                        <span
                          class="state-label"
                          [class.critical-label]="isLastEvaluationCritical(equipment)"
                          [class.non-critical-state]="!isLastEvaluationCritical(equipment)"
                        >
                          {{ getLastEvaluationStatus(equipment) }}
                        </span>
                      </span>
                    </div>

                    <div class="equipment-info perimeter-info" *ngIf="endOfLifeYear">
                      <span class="info-item">
                        <span class="quantity-color">{{ 'End of life currently foreseen in' | translate }} : </span>
                        <span class="end-of-life-year">{{ endOfLifeYear }}</span>
                      </span>
                    </div>

                    <div class="equipment-info perimeter-info">
                      <span class="info-item">
                        <span class="quantity-color" *ngIf="showQuantityUnit(equipment)">{{ getQuantity(equipment) }}</span>
                      </span>
                    </div>
                  </div>
                </div>
                @if (!readOnly) {
                  <div class="equipment-link-icon" (click)="detachEquipment(equipment, $event)" [title]="'Detach equipment' | translate">
                    <i class="fa-light fa-link-slash"></i>
                  </div>
                }
              </div>
            }
          </div>
          @if (showLinkButton()) {
            <div class="footer-icon">
              <button class="paperclip-icon rounded-circle border border-0" (click)="openAttachEquipmentDialog()">
                <i class="fa-light fa-link"></i>
              </button>
            </div>
          }
        }
      }
    }
    <!-- Futur équipement (Remplacement + next_asset existant) -->
    @if (showFutureEquipment) {
      <div class="future-equipment-section" [class.has-separator]="equipmentList.length > 0">
        <app-future-equipment-form
          #futureForm
          [nextAsset]="nextAsset"
          [currentAsset]="currentAsset"
          [readOnly]="isInvestmentClosed"
          [investmentId]="investmentId"
          [buildingPerimeterId]="siteId"
          [installationYear]="installationYear"
          (saved)="onNextAssetSaved($event)"
        ></app-future-equipment-form>
      </div>
    }
  </nb-card-body>

  @if (showFutureEquipment && futureForm?.isDirty) {
    <nb-card-footer class="future-equipment-footer">
      <button
        nbButton
        fullWidth
        [disabled]="!futureForm?.isValid() || futureForm?.saving"
        (click)="futureForm?.save()"
      >
        @if (futureForm?.saving) {
          <nb-spinner status="control" size="tiny" message=""></nb-spinner>
        } @else {
          {{ 'Save' | translate }}
        }
      </button>
    </nb-card-footer>
  }
</nb-card>

